<template>
  <div id="app">
    <LayoutHeader />
    <LayoutContent />
    <LayoutFooter />
    <LayoutWarningLGPD />

    <BaseSpinner />
    <LayoutNotification />
  </div>
</template>

<script>
import LayoutHeader from './components/layout/LayoutHeader'
import LayoutContent from './components/layout/LayoutContent'
import LayoutFooter from './components/layout/LayoutFooter'
import LayoutWarningLGPD from './components/layout/LayoutWarningLGPD.vue'
import BaseSpinner from './components/global/BaseSpinner'
import LayoutNotification from './components/layout/LayoutNotification'

export default {
  name: 'App',
  components: {
    LayoutHeader,
    LayoutContent,
    LayoutFooter,
    LayoutWarningLGPD,
    BaseSpinner,
    LayoutNotification
  },
  methods: {
    spinnerLoad () {
      setTimeout(() => {
        this.$root.$emit('Spinner::hide')
      }, 300)
    },
    timeSignOut () {
      var time
      window.onload = resetTimer
      // DOM Events
      document.onmousemove = resetTimer
      document.onkeypress = resetTimer
      document.onclick = resetTimer

      const logout = () => {
        this.signOut()
        clearTimeout(time)
      }

      function resetTimer () {
        clearTimeout(time)
        time = setTimeout(logout, 600000) // 1000 milliseconds = 1 second
      }
    },
    signOut () {
      // Se o path for diferente de login ele segue
      if (this.$route.path !== '/login') {
        // Pega o usuário atual
        this.$firebase.database().ref(`users/${window.uid}`)
          .on('value', (data) => {
            const userCurrent = data.val()

            if (userCurrent) {
              // Se o usuário não for admin ele desconecta e volta a tela de login
              if (!userCurrent.admin) {
                this.$firebase.auth().signOut()
                  .then(() => {
                    this.$firebase.auth().onAuthStateChanged(user => {
                      if (!user) {
                        window.uid = ''
                        this.$router.push({ name: 'login' }).catch(error => {
                          // Não lê o erro NavigationDuplicated
                          if (error.name !== 'NavigationDuplicated') {
                            throw error
                          }
                        })
                      }
                    })
                  })
                  .catch(error => {
                    console.error(error)
                  })
              }
            }
          })
      }
    }
  },
  mounted () {
    this.spinnerLoad()
    this.timeSignOut()
  }
}
</script>

<style lang="scss" scoped>
#app {
  height: 100vh;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 80px 1fr 120px;
  grid-template-areas:
  "header"
  "content"
  "footer";
}
</style>
